var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Вакантные места"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "loading": _vm.uploadExcel,
      "color": "primary"
    },
    on: {
      "click": _vm.chooseExcelFile
    }
  }, [_c('input', {
    ref: "excelInput",
    staticClass: "upload-excel-input",
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx"
    },
    on: {
      "change": _vm.uploadFromExcel
    }
  }), _c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-table-arrow-down")]), _vm._v(" Загрузить из EXCEL ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary",
      "loading": _vm.downloadExcel
    },
    on: {
      "click": _vm.downloadFromExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-table-arrow-up")]), _vm._v(" Сохранить в EXCEL ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "filter": "",
      "table-items": _vm.vacancyParent.list
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function fn() {
        return [_c('v-badge', {
          attrs: {
            "overlap": "",
            "dot": "",
            "value": !!_vm.checkFilterProperties(_vm.vacancyFilter)
          }
        }, [_c('v-btn', {
          staticClass: "white--text ml-4 filter-btn",
          attrs: {
            "small": "",
            "rounded": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = !_vm.showFilter;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-filter-outline")]), _c('span', [_vm._v(_vm._s(_vm.showFilter ? 'Закрыть' : 'Фильтр'))])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil-outline ")]), _c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }])
  })], 1), _c('transition', {
    attrs: {
      "name": "curator-filter"
    }
  }, [_c('VacancyFilterComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "filter": _vm.vacancyFilter,
      "width-filter": "300",
      "top": "255",
      "right": "29"
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1), _c('VacanciesDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "saveBtnLoading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem
    },
    on: {
      "saveVacancy": _vm.saveVacancy,
      "closeModal": _vm.closeDialog
    }
  }), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430?"
    },
    on: {
      "confirm": _vm.removeVacancy,
      "closeModal": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }